import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { FieldInfoGroupField, HiddenField } from '@app/common/configurable-wizards';
import { Field } from '@app/common/configurable-wizards/types';

import { UrlParams } from '../types';

import { getUrlToField } from '../utils/paths';

export const useDetailsSectionNavigator = () => {
  const history = useHistory();

  const { sectionId } = useParams<UrlParams>();
  const navigate = useCallback((item: FieldInfoGroupField) => {
    const fieldId = item.subFields.find(
      (subField) => (subField as Field).id === 'UniqueId',
    ) as HiddenField;

    if (fieldId?.sValue) {
      history.push(
        getUrlToField(
          sectionId,
          fieldId.sValue,
        ),
      );
    }
  }, []);

  return {
    navigate,
  };
};
